export enum MemberType { // allowed types
    USER = "USER", 
    RESTAURANT = "RESTAURANT",
}

export enum MemberStatus { // member status can be one of them only. Fixed values
    ACTIVE = "ACTIVE",
    BLOCK = "BLOCK",
    DELETE = "DELETE",
}